export default __webpack_public_path__ + "static/camera-van-2cb73c2ddea1090ebadadd60534ce4cd.png";